// extracted by mini-css-extract-plugin
export default {"container":"ResendVerificationEmailButton_container__gOlh-","btn":"ResendVerificationEmailButton_btn__mdZ0+","errorMessage":"ResendVerificationEmailButton_errorMessage__lsTu5"};